import { render, staticRenderFns } from "./EntityOffice.vue?vue&type=template&id=1af16e7a"
import script from "./EntityOffice.vue?vue&type=script&lang=ts"
export * from "./EntityOffice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports